import { ReactNode } from 'react';

type InlineCodeProps = { children: ReactNode };

export default function InlineCode({ children }: InlineCodeProps) {
  return (
    <code className="inline rounded bg-whisper p-1 text-cornflower">
      {children}
    </code>
  );
}
